module.exports = __webpack_public_path__ + "Employer Notice 07_08_2024.pdf";